import { connect } from "react-redux";
import * as invoiceActions from "./actions";

//Used to format the dates correctly without timezone (ToDo add this globally somehow?)
import moment from "moment";

function mapStateToProps(state) {
  return {
    invoices: state.userInvoices.invoices,
    stInvoices: state.userInvoices.shortTermInvoices,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    removeInvoiceRow: (loanId, invoiceId, rowId, draft) => {
      dispatch(
        invoiceActions.remove_invoice_row(loanId, invoiceId, rowId, draft),
      );
    },

    /*getInvoicesByAccount: accountId => {
			dispatch(invoiceActions.get_invoices_by_account(accountId));
		},*/

    changeInvoiceListPage: (page) => {
      dispatch(invoiceActions.change_invoice_list_page(page));
    },

    changeInvoiceListFilter: (type, key, value) => {
      dispatch(invoiceActions.change_invoice_list_filter(key, value));
    },

    getSTInvoicesByAccount: (accountId) => {
      dispatch(invoiceActions.get_st_invoices_by_account(accountId));
    },

    changeSTInvoiceListPage: (page) => {
      dispatch(invoiceActions.change_st_invoice_list_page(page));
    },

    changeSTInvoiceListFilter: (type, key, value) => {
      dispatch(invoiceActions.change_st_invoice_list_filter(key, value));
    },

    registerPayment: (
      loanId,
      customerRefCode,
      staffRefCode,
      amount,
      receiveDate,
    ) => {
      receiveDate = moment(receiveDate).format("YYYY-MM-DD");
      dispatch(
        invoiceActions.register_invoice_payment(
          loanId,
          customerRefCode,
          staffRefCode,
          amount,
          receiveDate,
        ),
      );
    },
  };
}

export const userInvoicesConnector = connect(
  mapStateToProps,
  mapDispatchToProps,
);
